module.exports = __webpack_public_path__ + "img/progress_085.d603d709.png";